if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.hasLoggedMediaBrightnessError = false;
    }

    connectedCallback() {
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.preventResize = false;
      this.header = document.querySelector('.section-header');
      this.headerTop = document.querySelector('.header-top');

      // 设置设备类型
      this.isDesktop = !(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) && window.innerWidth >= 990;

      // 监听幻灯片切换事件
      this.slideContainer = document.querySelector('slideshow-component');

      if (this.slideContainer) {
        this.onSlideChangedHandler = this.onSlideChanged.bind(this);
        this.slideContainer.addEventListener('slideChanged', this.onSlideChangedHandler);

        // 页面加载时检测第一张幻灯片的图片亮度
        this.detectInitialSlide();
      }


      // 颜色配置
      this.themeColors = {
        light: '#fff',
        dark: '#000'
      };

      // 检查是否是index页面
      this.isHomePage = this.classList.contains('absolute');


      // header 内部元素
      this.headerInner = document.querySelector('header')
      this.headerMenuItems = this.headerInner.querySelectorAll('.header__menu-item');

      // 桌面端元素
      this.rightSearch = this.headerInner.querySelector('.right_search svg');
      this.rightAccount = this.headerInner.querySelector('.down_nav_right_account .header__icon .icon-account');
      this.rightCart = this.headerInner.querySelector('.down_nav_right_a .header__cart-inner');
      this.cartIcon = this.rightCart ? this.rightCart.querySelector('.icon-cart') : null;
      this.cartSubtotal = this.rightCart ? this.rightCart.querySelector('.header__cart-total__label') : null;
      this.cartTotalPrice = this.rightCart ? this.rightCart.querySelector('.header__cart-total__price') : null;

      // 移动端元素
      this.mobileSearch = this.headerInner.querySelector('.header-mobile-search-icon-box svg');
      this.mobileAccount = this.headerInner.querySelector('.header-mobile-customer-icon svg');
      this.mobileCart = this.headerInner.querySelector('.header-mobile-cart-icon.header__icon svg');
      this.mobileMenu = this.headerInner.querySelector('.header__icon--menu');


      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.isToggleNav = this.classList.contains('toggle-nav');
      this.calculateThreshold();
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.isToggleNav) {
        this.header.classList.add('toggle-nav');
        this.toggleNavButton = this.querySelector('.header__toggle-nav-button');
        this.onToggleNavClickHandler = this.onToggleNavClick.bind(this);
        this.toggleNavButton.addEventListener('click', this.onToggleNavClickHandler);
        this.nav = this.querySelector('.header__inline-menu');
        setTimeout(() => {
          document.body.style.setProperty('--nav-height', `${this.nav.clientHeight}px`);
        }, 500);
      }

      // 添加鼠标划入/划出事件
      this.onHeaderMouseEnterHandler = this.onHeaderMouseEnter.bind(this);
      this.onHeaderMouseLeaveHandler = this.onHeaderMouseLeave.bind(this);
      this.headerInner.addEventListener('mouseenter', this.onHeaderMouseEnterHandler);
      this.headerInner.addEventListener('mouseleave', this.onHeaderMouseLeaveHandler);

      this.onScroll();

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.onResizeThemeHandler = this.onResizeTheme.bind(this);
      window.addEventListener('resize', this.onResizeThemeHandler, false);

      this.setupWindowResizeEvent();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.debouncedOnWindowResize);
      window.removeEventListener('resize', this.onResizeThemeHandler);

      // 移除鼠标事件监听
      if (this.headerInner) {
        this.headerInner.removeEventListener('mouseenter', this.onHeaderMouseEnterHandler);
        this.headerInner.removeEventListener('mouseleave', this.onHeaderMouseLeaveHandler);
      }

      if (this.toggleNavButton) {
        this.toggleNavButton.removeEventListener('click', this.onToggleNavClickHandler);
      }

      // 移除幻灯片切换事件监听
      if (this.slideContainer && this.onSlideChangedHandler) {
        this.slideContainer.removeEventListener('slideChanged', this.onSlideChangedHandler);
      }
    }

    calculateThreshold() {
      this.headerBoundTop = this.header.getBoundingClientRect().bottom + (window.pageYOffset || document.documentElement.scrollTop);
      this.threshold = this.headerBoundTop + 100;
    }

    onScroll() {
      const scrollTop = document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop & scrollTop > this.headerBoundTop) {

        // Scrolling down and passed the header: hide the sticky header but keep position fixed.
        if (this.preventHide) return;
        // requestAnimationFrame(this.hide.bind(this));
        // 改为固定显示
        requestAnimationFrame(this.reveal.bind(this));
        this.setHeaderTheme(true);
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBoundTop) {
        // Scrolling up and passed the header: show the sticky header.
        if (!this.preventReveal && scrollTop > this.threshold) {
          requestAnimationFrame(this.reveal.bind(this));
          // 切换为深色主题（黑色文字和图标）
          this.setHeaderTheme(true);
        } else {
          // 切换为浅色主题（白色文字和图标） &&   剔除不在主页的
          if (this.isHomePage) {
            this.setHeaderTheme(false);
          }


          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);


          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBoundTop) {
        // Scroll above the header: reset the sticky header.
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    setupWindowResizeEvent() {
      const headerHeight = this.header.querySelector('header').clientHeight;
      const stickyHeaderHeight = headerHeight + this.getHeaderTopHeight();
      document.body.style.setProperty('--header-height', `${headerHeight}px`);
      if (window.innerWidth >= 990) {
        document.body.style.setProperty('--sticky-header-height-desktop', `${stickyHeaderHeight}px`);
      } else {
        document.body.style.setProperty('--sticky-header-height-mobile', `${stickyHeaderHeight}px`);
      }
      this.debouncedOnWindowResize = debounce((event) => {
        this.onWindowResize(event);
      }, 500);

      window.addEventListener('resize', this.debouncedOnWindowResize, false);
    }

    onWindowResize() {
      if (this.preventResize) return;
      let headerHeight;
      if (this.isToggleNav && window.innerWidth >= 990) {
        const navHeight = this.nav.clientHeight;
        document.body.style.setProperty('--nav-height', `${navHeight}px`);
        if (this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('open-nav')) {
          headerHeight = this.header.querySelector('header').clientHeight + navHeight + 11;
        } else {
          headerHeight = this.header.querySelector('header').clientHeight;
        }
      } else {
        headerHeight = this.header.querySelector('header').clientHeight;
      }
      document.body.style.setProperty('--header-height', `${headerHeight}px`);
      const stickyHeaderHeight = headerHeight + this.getHeaderTopHeight();
      if (window.innerWidth >= 990) {
        document.body.style.setProperty('--sticky-header-height-desktop', `${stickyHeaderHeight}px`);
      } else {
        document.body.style.setProperty('--sticky-header-height-mobile', `${stickyHeaderHeight}px`);
      }
      this.calculateThreshold();
    }

    getHeaderTopHeight() {
      if (!this.headerTop) {
        return 0;
      }
      return this.headerTop.clientHeight;
    }

    onToggleNavClick() {
      document.body.style.setProperty('--nav-height', `${this.nav.clientHeight}px`);
      this.header.classList.toggle('open-nav');
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.closeToggleNav();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.dataset.toggleNav) {
        this.toggleNavButton.removeAttribute('tabindex');
      }
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.closeToggleNav();

      // 页面回到顶部时，移除白色背景类（因为不在 sticky 状态）
      this.headerInner.classList.remove('header-bgc-fff');

      // 页面回到顶部时，重新检测当前激活幻灯片的图片亮度
      if (this.isHomePage && this.slideContainer) {
        // 获取当前激活的幻灯片（通过查找当前可见的幻灯片）
        const slider = this.slideContainer.querySelector('[id^="Slider-"]');
        if (slider) {
          const slides = this.slideContainer.querySelectorAll('[id^="Slide-"]');
          // 查找当前可见的幻灯片（在视口内的）
          let currentSlide = null;
          for (const slide of slides) {
            const rect = slide.getBoundingClientRect();
            if (rect.left < slider.clientWidth && rect.right > 0) {
              currentSlide = slide;
              break;
            }
          }
          // 如果没有找到可见的，使用第一张
          if (!currentSlide && slides.length > 0) {
            currentSlide = slides[0];
          }
          if (currentSlide) {
            this.detectSlideImageBrightness(currentSlide);
          }
        }
      }
    }

    closeToggleNav() {
      if (this.dataset.toggleNav) {
        this.toggleNavButton.setAttribute('tabindex', '-1');
        this.header.classList.remove('open-nav');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }

    /**
     *
     * @param {boolean} isDark - 是否为深色主题
     */
    setHeaderTheme(isDark) {
      const colorClass = 'header-font-color-black';
      const bgClass = 'header-bgc-fff';

      // 检查 header 是否在 sticky 状态（reveal 状态）
      const isSticky = this.header.classList.contains('shopify-section-header-sticky');
      // 检查是否在鼠标移入状态（hover 状态）
      const isHover = this.headerInner.classList.contains('header-hover');

      // 如果鼠标移入，强制使用深色主题（黑色文字+白色背景）
      // 这样可以避免幻灯片切换时改变hover状态下的样式
      const effectiveIsDark = isHover ? true : isDark;
      const fillColor = effectiveIsDark ? this.themeColors.dark : this.themeColors.light;

      // 白色背景在以下情况下添加：
      // 1. sticky 状态下且 isDark 为 true（reveal 时）
      // 2. 鼠标移入时（hover 状态）- 强制使用深色主题，保持白色背景
      // 在顶部时（reset 状态），只有鼠标移入时才添加白色背景
      if (isHover || (isSticky && isDark)) {
        this.headerInner.classList.add(bgClass);
      } else {
        this.headerInner.classList.remove(bgClass);
      }

      this.headerMenuItems.forEach(item => {
        item.classList[effectiveIsDark ? 'add' : 'remove'](colorClass);
      });

      if (this.isDesktop) {
        // 桌面端图标颜色设置
        this.setSvgColor(this.rightSearch, fillColor);
        this.setSvgColor(this.rightAccount, fillColor);
        this.setSvgColor(this.cartIcon, fillColor);

        if (this.cartSubtotal) this.cartSubtotal.classList[effectiveIsDark ? 'add' : 'remove'](colorClass);
        if (this.cartTotalPrice) this.cartTotalPrice.classList[effectiveIsDark ? 'add' : 'remove'](colorClass);
      } else {
        // 移动端图标颜色设置
        this.setSvgColor(this.mobileSearch, fillColor);
        this.setSvgColor(this.mobileAccount, fillColor);
        this.setSvgColor(this.mobileCart, fillColor);
        this.mobileMenu.style.color = fillColor;
      }
    }

    /**
     * SVG颜色
     * @param {Element} svgElement - SVG元素
     * @param {string} color - 颜色值
     */
    setSvgColor(svgElement, color) {
      if (!svgElement) return;

      const paths = svgElement.querySelectorAll('path, circle, rect');
      paths.forEach(path => {
        path.setAttribute('fill', color);
      });
    }

    /**
     * 响应窗口大小变化，重新应用当前主题
     */
    onResizeTheme() {
      // 更新设备类型
      this.isDesktop = window.innerWidth >= 990;

      // 如果当前在sticky状态下，根据滚动位置重新应用主题
      if (this.header.classList.contains('shopify-section-header-sticky')) {
        const isDark = window.scrollY > this.threshold;
        this.setHeaderTheme(isDark);
      }
    }

    /**
     * 处理鼠标进入header的事件
     * 当页面在顶部时（初始状态或滚动回顶部），鼠标划入改变背景色和文字颜色
     */
    onHeaderMouseEnter() {
      // 只有当页面在顶部时才应用hover效果  
      if (window.scrollY <= this.headerBoundTop) {
        // 先添加 hover 类，这样 setHeaderTheme 才能检测到 hover 状态
        this.headerInner.classList.add('header-hover');
        // 切换为深色主题（黑色文字和图标、白色背景）
        this.setHeaderTheme(true);
      }
    }

    /**
     * 处理鼠标离开header的事件
     * 当页面在顶部时，鼠标划出恢复原来的颜色（透明背景）
     */
    onHeaderMouseLeave() {
      // 只有当页面在顶部时才需要恢复
      if (window.scrollY <= this.headerBoundTop && this.isHomePage) {
        // 先移除 hover 类，这样 setHeaderTheme 才能正确检测到 hover 状态已移除
        this.headerInner.classList.remove('header-hover');

        // 重新检测当前幻灯片的图片亮度，恢复正确的主题（透明背景）
        if (this.slideContainer) {
          const slider = this.slideContainer.querySelector('[id^="Slider-"]');
          if (slider) {
            const slides = this.slideContainer.querySelectorAll('[id^="Slide-"]');
            // 查找当前可见的幻灯片
            let currentSlide = null;
            for (const slide of slides) {
              const rect = slide.getBoundingClientRect();
              if (rect.left < slider.clientWidth && rect.right > 0) {
                currentSlide = slide;
                break;
              }
            }
            // 如果没有找到可见的，使用第一张
            if (!currentSlide && slides.length > 0) {
              currentSlide = slides[0];
            }
            if (currentSlide) {
              this.detectSlideImageBrightness(currentSlide);
            } else {
              // 如果没有幻灯片，恢复为浅色主题（透明背景）
              this.setHeaderTheme(false);
            }
          } else {
            // 如果没有 slider，恢复为浅色主题（透明背景）
            this.setHeaderTheme(false);
          }
        } else {
          // 如果没有 slideContainer，恢复为浅色主题（透明背景）
          this.setHeaderTheme(false);
        }
      }
    }

    /**
     * 检测初始幻灯片（第一张）的图片亮度
     */
    async detectInitialSlide() {
      // 只在主页时检测
      if (!this.isHomePage) return;

      // 等待DOM完全加载
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          setTimeout(() => this.detectInitialSlide(), 100);
        });
        return;
      }

      // 获取第一张幻灯片
      const firstSlide = this.slideContainer?.querySelector('[id^="Slide-"]');

      if (!firstSlide) return;

      await this.detectSlideImageBrightness(firstSlide);
    }

    /**
     * 检测指定幻灯片元素的图片或视频亮度并设置header主题
     * @param {HTMLElement} slideElement - 幻灯片元素
     */
    async detectSlideImageBrightness(slideElement) {
      // 从幻灯片元素中获取媒体容器
      const mediaContainer = slideElement.querySelector('.banner__media, .media');
      if (!mediaContainer) return;

      // 为后续媒体请求补充跨域属性（对已加载资源不追溯，但可覆盖后续加载）
      this.ensureMediaCrossOrigin(mediaContainer);

      // 优先检测视频（如果存在）
      let video = null;
      // 桌面端视频（class包含banner-video，不包含mobile）
      video = mediaContainer.querySelector('video.banner-video__box:not([class*="mobile"])');

      // 如果没有桌面端视频，则获取移动端视频
      if (!video) {
        video = mediaContainer.querySelector('video.banner-video__box[class*="mobile"]');
      }

      // 如果还是没有，则获取任何video标签
      if (!video) {
        video = mediaContainer.querySelector('video');
      }

      try {
        let brightness;

        if (video) {
          // 检测视频第一帧亮度
          brightness = await this.detectVideoFirstFrameBrightness(video);
        } else {
          // 检测图片亮度
          // 桌面端图片（class包含small-hide，不包含medium-hide和large-up-hide）
          let img = mediaContainer.querySelector('img.small-hide:not(.medium-hide):not(.large-up-hide)');

          // 如果没有桌面端图片，则获取移动端图片
          if (!img) {
            img = mediaContainer.querySelector('img.medium-hide.large-up-hide');
          }

          // 如果还是没有，则获取任何img标签
          if (!img) {
            img = mediaContainer.querySelector('img');
          }

          if (!img) return;

          brightness = await this.detectImageBrightness(img);
        }

        // 深色图片/视频 -> 浅色字（isDark = false）
        // 浅色图片/视频 -> 深色字（isDark = true）
        const isDark = brightness === 'light';

        this.setHeaderTheme(isDark);
      } catch (error) {
        if (this.isCanvasSecurityError(error)) {
          // 跨域媒体导致 canvas 污染时，静默降级，避免持续报错
          if (this.isHomePage) {
            this.setHeaderTheme(false);
          }
          return;
        }

        if (!this.hasLoggedMediaBrightnessError) {
          console.warn('检测幻灯片媒体亮度失败:', error);
          this.hasLoggedMediaBrightnessError = true;
        }

        // 如果检测失败，使用默认的浅色主题
        if (this.isHomePage) {
          this.setHeaderTheme(false);
        }
      }
    }

    /**
     * 判断是否为 Canvas 安全策略（跨域）导致的像素读取失败
     * @param {unknown} error
     * @returns {boolean}
     */
    isCanvasSecurityError(error) {
      const message = String(error?.message || error || '');
      return message.includes('tainted by cross-origin data')
        || message.includes('The operation is insecure')
        || message.includes('SecurityError')
        || message.includes('跨域或权限问题');
    }

    /**
     * 给媒体元素设置匿名跨域，避免后续资源加载污染 Canvas
     * @param {HTMLElement} container
     */
    ensureMediaCrossOrigin(container) {
      const mediaElements = container.querySelectorAll('img, video');
      mediaElements.forEach((element) => {
        if (!element.getAttribute('crossorigin')) {
          element.setAttribute('crossorigin', 'anonymous');
        }
      });
    }

    /**
     * 获取媒体地址
     * @param {HTMLImageElement|HTMLVideoElement} mediaElement
     * @returns {string}
     */
    getMediaSourceUrl(mediaElement) {
      return mediaElement.currentSrc || mediaElement.src || mediaElement.getAttribute('src') || '';
    }

    /**
     * 是否跨域 URL
     * @param {string} url
     * @returns {boolean}
     */
    isCrossOriginUrl(url) {
      if (!url) return false;
      if (url.startsWith('data:') || url.startsWith('blob:')) return false;

      try {
        const absoluteUrl = new URL(url, window.location.href);
        return absoluteUrl.origin !== window.location.origin;
      } catch (error) {
        return false;
      }
    }

    /**
     * 等待图片加载
     * @param {HTMLImageElement} img
     * @returns {Promise<void>}
     */
    waitForImageLoad(img) {
      return new Promise((resolve, reject) => {
        if (img.complete && img.naturalWidth > 0) {
          resolve();
          return;
        }

        const onLoad = () => {
          img.removeEventListener('load', onLoad);
          img.removeEventListener('error', onError);
          resolve();
        };

        const onError = () => {
          img.removeEventListener('load', onLoad);
          img.removeEventListener('error', onError);
          reject(new Error('图片加载失败'));
        };

        img.addEventListener('load', onLoad);
        img.addEventListener('error', onError);
      });
    }

    /**
     * 获取可用于 canvas 检测的图片对象
     * @param {HTMLImageElement} img
     * @returns {Promise<HTMLImageElement>}
     */
    async getImageForAnalysis(img) {
      const sourceUrl = this.getMediaSourceUrl(img);
      if (!sourceUrl) {
        throw new Error('图片地址为空');
      }

      // 同源图片直接使用原对象
      if (!this.isCrossOriginUrl(sourceUrl)) {
        await this.waitForImageLoad(img);
        return img;
      }

      // 跨域图片创建匿名跨域分析副本
      const analysisImg = new Image();
      analysisImg.crossOrigin = 'anonymous';
      analysisImg.decoding = 'async';

      const loaded = this.waitForImageLoad(analysisImg);
      analysisImg.src = sourceUrl;
      await loaded;

      return analysisImg;
    }

    /**
     * 等待视频可用帧数据
     * @param {HTMLVideoElement} video
     * @returns {Promise<void>}
     */
    waitForVideoFrame(video) {
      return new Promise((resolve, reject) => {
        if (video.readyState >= video.HAVE_CURRENT_DATA) {
          resolve();
          return;
        }

        const onLoadedData = () => {
          video.removeEventListener('loadeddata', onLoadedData);
          video.removeEventListener('error', onError);
          resolve();
        };

        const onError = () => {
          video.removeEventListener('loadeddata', onLoadedData);
          video.removeEventListener('error', onError);
          reject(new Error('视频加载失败'));
        };

        video.addEventListener('loadeddata', onLoadedData);
        video.addEventListener('error', onError);
      });
    }

    /**
     * 获取可用于 canvas 检测的视频对象及清理函数
     * @param {HTMLVideoElement} video
     * @returns {Promise<{videoElement: HTMLVideoElement, cleanup: (() => void)|null}>}
     */
    async getVideoForAnalysis(video) {
      const sourceUrl = this.getMediaSourceUrl(video);
      if (!sourceUrl) {
        throw new Error('视频地址为空');
      }

      // 同源视频直接使用原对象
      if (!this.isCrossOriginUrl(sourceUrl)) {
        await this.waitForVideoFrame(video);
        return { videoElement: video, cleanup: null };
      }

      // 跨域视频创建匿名跨域分析副本
      const analysisVideo = document.createElement('video');
      analysisVideo.crossOrigin = 'anonymous';
      analysisVideo.muted = true;
      analysisVideo.playsInline = true;
      analysisVideo.preload = 'auto';
      analysisVideo.src = sourceUrl;

      analysisVideo.load();
      await this.waitForVideoFrame(analysisVideo);

      return {
        videoElement: analysisVideo,
        cleanup: () => {
          analysisVideo.pause();
          analysisVideo.removeAttribute('src');
          analysisVideo.load();
        }
      };
    }

    /**
     * 处理幻灯片切换事件
     * 每次幻灯片切换时，检测当前激活幻灯片的图片亮度并设置header主题
     * @param {CustomEvent} event - slideChanged事件，包含currentElement
     */
    async onSlideChanged(event) {
      // 直接使用事件中的currentElement（来自SliderComponent.update()）
      const currentElement = event.detail?.currentElement;
      if (!currentElement) return;

      // 只在主页且页面在顶部时，才根据幻灯片图片亮度设置header主题
      if (!this.isHomePage || window.scrollY > this.headerBoundTop) {
        return;
      }

      // 检测当前激活幻灯片的图片亮度
      await this.detectSlideImageBrightness(currentElement);
    }

    /**
     * 检测视频第一帧的明暗
     * @param {HTMLVideoElement} video - 目标视频元素
     * @param {number} threshold - 亮度阈值（默认 127）
     * @param {number} sampleStep - 抽样步长（默认 5，平衡性能和精度）
     * @returns {Promise<'dark'|'light'>} 检测结果
     */
    async detectVideoFirstFrameBrightness(video, threshold = 127, sampleStep = 5) {
      let cleanup = null;

      try {
        const analysis = await this.getVideoForAnalysis(video);
        const analysisVideo = analysis.videoElement;
        cleanup = analysis.cleanup;

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = analysisVideo.videoWidth;
        canvas.height = analysisVideo.videoHeight;

        ctx.drawImage(analysisVideo, 0, 0, canvas.width, canvas.height);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;
        let totalBrightness = 0;
        let sampledCount = 0;

        for (let i = 0; i < data.length; i += 4 * sampleStep) {
          if (data[i + 3] === 0) continue;
          const r = data[i];
          const g = data[i + 1];
          const b = data[i + 2];
          totalBrightness += r * 0.299 + g * 0.587 + b * 0.114;
          sampledCount++;
        }

        const avgBrightness = sampledCount > 0 ? totalBrightness / sampledCount : 0;
        return avgBrightness > threshold ? 'light' : 'dark';
      } catch (err) {
        throw new Error('检测失败（跨域或权限问题）：' + err.message);
      } finally {
        if (cleanup) {
          cleanup();
        }
      }
    }

    /**
     * 检测图片明暗
     * @param {HTMLImageElement} img - 目标图片元素
     * @param {number} threshold - 亮度阈值（默认 127）
     * @param {number} sampleStep - 抽样步长（默认 5，平衡性能和精度）
     * @returns {Promise<'dark'|'light'>} 检测结果
     */
    async detectImageBrightness(img, threshold = 127, sampleStep = 5) {
      try {
        const analysisImg = await this.getImageForAnalysis(img);

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = analysisImg.naturalWidth;
        canvas.height = analysisImg.naturalHeight;
        ctx.drawImage(analysisImg, 0, 0);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;
        let totalBrightness = 0;
        let sampledCount = 0;

        for (let i = 0; i < data.length; i += 4 * sampleStep) {
          if (data[i + 3] === 0) continue;
          const r = data[i];
          const g = data[i + 1];
          const b = data[i + 2];
          totalBrightness += r * 0.299 + g * 0.587 + b * 0.114;
          sampledCount++;
        }

        const avgBrightness = sampledCount > 0 ? totalBrightness / sampledCount : 0;
        return avgBrightness > threshold ? 'light' : 'dark';
      } catch (err) {
        throw new Error('检测失败（跨域或权限问题）：' + err.message);
      }
    }


  });
}